module.exports = __webpack_public_path__ + "a4e43ac4e3f9a80b368e8ea64e977e85.woff";